const HOTKEYS_ACTION_GLOBAL = {
    SHOW_HIDE:              0,
    CALL_CLIPBOARD_NUMBER:  1,
}

const COOKIE_STORE_KEYS = {
    IO: 'socket.io-cookie',
    VIDEOMOST: 'videomost-cookie',
    ACCESS_TOKEN: 'access-token-cookie',
    REFRESH_TOKEN: 'refresh-token-cookie',
}

const COOKIE_HEADER_NAMES = {
    IO: 'io',
    VIDEOMOST: 'PHPSESSID',
}

const WINDOW_NAMES = {
    MAIN: 'mainWindow',
    CONF: 'conf',
    SHARE_TOOLBAR: 'shareToolbar',
    PHONE: 'phone',
    INCOMING_CALL: 'phoneIncomming',
    NOTIFICATION: 'notification',
    SYSTEM_NOTIFICATION: 'systemNotification',
    OAUTH: 'oauth',
}

const IPC_EVENTS = {
    OPEN_WINDOW: 'open-window',
    UPDATE_WINDOW: 'update-window',
    CLOSE_WINDOW: 'close-window',
    SET_WINDOW_SIZE: 'set-window-size',
    SHOW_MAIN_WINDOW: 'show-main-window',
    SET_EVENTS_COUNT: 'set-events-count',
    TOGGLE_WINDOW_ON_TOP: 'toggle-window-on-top',
    TOGGLE_WINDOW_MINIMIZE: 'toggle-window-minimize',
    TOGGLE_WINDOW_FULLSCREEN: 'toggle-window-fullscreen',
}

module.exports = {
    HOTKEYS_ACTION_GLOBAL,
    COOKIE_STORE_KEYS,
    COOKIE_HEADER_NAMES,
    WINDOW_NAMES,
    IPC_EVENTS,
}